import { P, Strong } from '@ahmdigital/ui';
import React from 'react';

import { NoResultsContent } from './styles';

const NoResultsMessage = () => (
  <NoResultsContent>
    <P>
      <Strong>Location not found.</Strong> Please check you have the correct destination.
    </P>
  </NoResultsContent>
);

export default NoResultsMessage;
